$(document).on('input', '.js-inputSearch', function() {
	const _this = $(this);
	const parent = _this.parent();
	const value = _this.val().toLowerCase();

	if (_this.val().length > 0) {
		parent.addClass('has_value')
	} else {
		parent.removeClass('has_value')
	}

	searchElems(value);
});

function searchElems(value) {
	$('.js-searchElem').each(function(){
		const searchElemTitle = $(this).find('.js-searchElemTitle').text().toLowerCase();

		if(searchElemTitle.indexOf(value) > -1){
			$(this).show();
		} else {
			$(this).hide();
		}
	});
}

$(document).on('click', '.js-inputSearchReset', function() {
	const _this = $(this);
	const parent = _this.parent();

	parent.find('.js-inputSearch').val('');
	parent.removeClass('has_value');

	const value = $('.js-inputSearch').val();

	searchElems(value);
});